import { Component, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TourService } from '../../services/tour/tour.service';

@Component({
  selector: 'app-help-button',
  template: `
    <details #dd class="dropdown dropdown-end">
      <summary
        class="list-none w-7 h-7 rounded-full border-[1.5px] border-gray-400 text-gray-600 font-bold text-sm flex items-center justify-center hover:border-primary hover:text-primary transition-colors cursor-pointer"
        title="Help"
        aria-label="Help"
      >
        ?
      </summary>
      <ul
        class="dropdown-content menu menu-sm bg-base-100 rounded-box shadow-lg w-64 z-50 mt-2 p-2 border border-gray-200"
      >
        @if (pageHelpAvailable()) {
          <li>
            <button type="button" (click)="onStartHere()">Start from here</button>
          </li>
        } @else {
          <li class="menu-title">
            <span class="text-xs text-gray-500 font-normal normal-case px-2 py-1 leading-snug">
              No tour for this page. Take the full tour to see every section.
            </span>
          </li>
        }
        <li>
          <button type="button" (click)="onFullTour()">Take the full tour</button>
        </li>
      </ul>
    </details>
  `,
})
export class HelpButtonComponent {
  private readonly tour = inject(TourService);
  private readonly router = inject(Router);

  @ViewChild('dd') private dd?: ElementRef<HTMLDetailsElement>;

  readonly pageHelpAvailable = signal(this.tour.hasPageHelp(this.router.url));

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.pageHelpAvailable.set(this.tour.hasPageHelp(e.urlAfterRedirects)));
  }

  onStartHere(): void {
    this.close();
    this.tour.startPageHelp();
  }

  onFullTour(): void {
    this.close();
    this.tour.replay();
  }

  private close(): void {
    if (this.dd?.nativeElement) this.dd.nativeElement.open = false;
  }
}
